import React from 'react';
import { X } from 'lucide-react';
import { Task } from '../../types';

interface ProductsModalProps {
  task: Task;
  products: Array<{
    name: string;
    planned_quantity?: number;
    actual_quantity?: number | null;
    planned_quantity_kg?: number;
    actual_quantity_kg?: number | null;
  }>;
  onClose: () => void;
}

const ProductsModal: React.FC<ProductsModalProps> = ({ task, products, onClose }) => {
  const isEngrais = task.type === 'engrais';
  const unit = isEngrais ? 'kg' : '';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold">Liste des produits</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 font-medium text-gray-600 border-b pb-2">
            <div>Produit</div>
            <div>Quantité {isEngrais && '(kg)'}</div>
          </div>

          {products.map((product, index) => {
            const plannedQty = isEngrais ? product.planned_quantity_kg : product.planned_quantity;
            const actualQty = isEngrais ? product.actual_quantity_kg : product.actual_quantity;

            return (
              <div key={index} className="grid grid-cols-2 gap-4">
                <div>{product.name}</div>
                <div>
                  {plannedQty} {unit}
                  {actualQty !== null && actualQty !== undefined && (
                    <span className="text-gray-500 ml-2">
                      ({actualQty} {unit} livrés)
                    </span>
                  )}
                </div>
              </div>
            );
          })}

          {products.length === 0 && (
            <div className="text-center text-gray-500 py-4">
              Aucun produit trouvé
            </div>
          )}
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductsModal;